module.exports = __webpack_public_path__ + "static/img/vote-01.2f73182.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vote/vote-01.png
// module id = B4tH
// module chunks = 1